export default __webpack_public_path__ + "static/media/airport.b86627a1.svg";